/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_ConditionInputs */

const en_field_condition = /** @type {(inputs: Field_ConditionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Condition`)
};

const es_field_condition = /** @type {(inputs: Field_ConditionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estado`)
};

const fr_field_condition = /** @type {(inputs: Field_ConditionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`État`)
};

const de_field_condition = /** @type {(inputs: Field_ConditionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zustand`)
};

const ja_field_condition = /** @type {(inputs: Field_ConditionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`状態`)
};

const zh_field_condition = /** @type {(inputs: Field_ConditionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`物品状况`)
};

const ar_field_condition = /** @type {(inputs: Field_ConditionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الحالة`)
};

const id_field_condition = /** @type {(inputs: Field_ConditionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kondisi`)
};

const it_field_condition = /** @type {(inputs: Field_ConditionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Condizione`)
};

const ru_field_condition = /** @type {(inputs: Field_ConditionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Состояние`)
};

const pt_field_condition = /** @type {(inputs: Field_ConditionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Condição`)
};

const ko_field_condition = /** @type {(inputs: Field_ConditionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`상태`)
};

/**
* | output |
* | --- |
* | "Condition" |
*
* @param {Field_ConditionInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_condition = /** @type {((inputs?: Field_ConditionInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_ConditionInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_condition(inputs)
	if (locale === "es") return es_field_condition(inputs)
	if (locale === "fr") return fr_field_condition(inputs)
	if (locale === "de") return de_field_condition(inputs)
	if (locale === "ja") return ja_field_condition(inputs)
	if (locale === "zh") return zh_field_condition(inputs)
	if (locale === "ar") return ar_field_condition(inputs)
	if (locale === "id") return id_field_condition(inputs)
	if (locale === "it") return it_field_condition(inputs)
	if (locale === "ru") return ru_field_condition(inputs)
	if (locale === "pt") return pt_field_condition(inputs)
	return ko_field_condition(inputs)
});